import { lazyPreload } from 'helpers/lazyPreload'

export const CancelOfferQuestionV1 = lazyPreload(() =>
  import('./CancelOffer/CancelOfferQuestionV1').then((m) => ({
    default: m.CancelOfferQuestionV1,
  })),
)

export const CancelOfferQuestionV2 = lazyPreload(() =>
  import('./CancelOffer/CancelOfferQuestionV2').then((m) => ({
    default: m.CancelOfferQuestionV2,
  })),
)

export const CancelOfferQuestionV3 = lazyPreload(() =>
  import('./CancelOffer/CancelOfferQuestionV3').then((m) => ({
    default: m.CancelOfferQuestionV3,
  })),
)

export const CancelOfferSubscriptionV1 = lazyPreload(() =>
  import('./CancelOffer/CancelOfferSubscription').then((m) => ({
    default: m.CancelOfferSubscriptionV1,
  })),
)

export const CancelOfferSubscriptionV2 = lazyPreload(() =>
  import('./CancelOffer/CancelOfferSubscription').then((m) => ({
    default: m.CancelOfferSubscriptionV2,
  })),
)

export const CancelOfferSubscriptionV3 = lazyPreload(() =>
  import('./CancelOffer/CancelOfferSubscription').then((m) => ({
    default: m.CancelOfferSubscriptionV3,
  })),
)

export const CancelOfferSubscriptionV4 = lazyPreload(() =>
  import('./CancelOffer/CancelOfferSubscription').then((m) => ({
    default: m.CancelOfferSubscriptionV4,
  })),
)

export const CancelOfferSubscriptionV5 = lazyPreload(() =>
  import('./CancelOffer/CancelOfferSubscription').then((m) => ({
    default: m.CancelOfferSubscriptionV5,
  })),
)

export const ChooseTrialPrice = lazyPreload(() =>
  import('./ChooseTrialPrice').then((m) => ({ default: m.ChooseTrialPrice })),
)

export const InappHowTo = lazyPreload(() =>
  import('./Upsell/pages/InappHowTo').then((m) => ({ default: m.InappHowTo })),
)

export const InappPodcast = lazyPreload(() =>
  import('./Upsell/pages/UpsellPodcast').then((m) => ({
    default: m.InappPodcast,
  })),
)

export const InappStressRelive = lazyPreload(() =>
  import('./Upsell/pages/InappStressRelive').then((m) => ({
    default: m.InappStressRelive,
  })),
)

export const InappUpsell = lazyPreload(() =>
  import('./Upsell/pages/InappUpsell').then((m) => ({
    default: m.UpsellGuideFactory,
  })),
)

export const PaymentLong = lazyPreload(() =>
  import('./Payment').then((m) => ({ default: m.PaymentLong })),
)

export const PaywallArchetypeAyah = lazyPreload(() =>
  import('./Purchase/PurchaseLong').then((m) => ({
    default: m.PaywallArchetypeAyah,
  })),
)

export const WellnessPaywall = lazyPreload(() =>
  import('./Purchase/PurchaseLong').then((m) => ({
    default: m.WellnessPaywall,
  })),
)

export const PaywallUS = lazyPreload(() =>
  import('./Purchase/PurchaseLong').then((m) => ({ default: m.PaywallUS })),
)

export const PurchaseLong = lazyPreload(() =>
  import('./Purchase/PurchaseLong').then((m) => ({ default: m.PurchaseLong })),
)

export const PurchaseLongV2 = lazyPreload(() =>
  import('./Purchase/PurchaseLong').then((m) => ({
    default: m.PurchaseLongV2,
  })),
)

export const PurchaseLongV3Factory = lazyPreload(() =>
  import('./Purchase/PurchaseLong').then((m) => ({
    default: m.PurchaseLongV3Factory,
  })),
)

export const PurchaseLongV4 = lazyPreload(() =>
  import('./Purchase/PurchaseLong').then((m) => ({
    default: m.PurchaseLongV4,
  })),
)

export const PurchaseLongV5 = lazyPreload(() =>
  import('./Purchase/PurchaseLong').then((m) => ({
    default: m.PurchaseLongV5,
  })),
)

export const PurchaseLongV6 = lazyPreload(() =>
  import('./Purchase/PurchaseLong').then((m) => ({
    default: m.PurchaseLongV6,
  })),
)

export const PurchaseV3KarmaTrial = lazyPreload(() =>
  import('./Purchase/PurchaseLong').then((m) => ({
    default: m.PurchaseV3KarmaTrial,
  })),
)

export const UpsellAddonsAyah = lazyPreload(() =>
  import('./Upsell/pages/UpsellAddonsAyah').then((m) => ({
    default: m.UpsellAddonsAyah,
  })),
)

export const InappVoiceover = lazyPreload(() =>
  import('./Upsell/pages/InappVoiceover').then((m) => ({
    default: m.InappVoiceoverFactory,
  })),
)

export const InappVoiceover2 = lazyPreload(() =>
  import('./Upsell/pages/InappVoiceover').then((m) => ({
    default: m.InappVoiceoverV2,
  })),
)

export const InappVoiceoverV3 = lazyPreload(() =>
  import('./Upsell/pages/InappVoiceover').then((m) => ({
    default: m.InappVoiceoverV3,
  })),
)

export const UpsellAyahPornAddiction = lazyPreload(() =>
  import('./Upsell/pages/UpsellAyahPornAddiction').then((m) => ({
    default: m.UpsellAyahPornAddiction,
  })),
)

export const UpsellCancelQuestion = lazyPreload(() =>
  import('./Upsell/pages/UpsellCancelQuestion').then((m) => ({
    default: m.UpsellCancelQuestion,
  })),
)

export const UpsellGuide = lazyPreload(() =>
  import('./Upsell/pages/UpsellGuide').then((m) => ({
    default: m.UpsellGuide,
  })),
)

export const UpsellParenting = lazyPreload(() =>
  import('./Upsell/pages/UpsellParenting').then((m) => ({
    default: m.UpsellParenting,
  })),
)

export const UpsellPodcast = lazyPreload(() =>
  import('./Upsell/pages/UpsellPodcast').then((m) => ({
    default: m.UpsellPodcast,
  })),
)
